import { Outlet } from "react-router-dom";

const AccountManager = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default AccountManager;
